<template>
  <el-container v-title data-title="发送工资条" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>消息管理</el-breadcrumb-item>
                <el-breadcrumb-item>发送工资条</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form ref="addForm" :inline="true" :model="addData" :rules="rules" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="addData.schoolId">
                    <el-option v-if="schoolList != null && schoolList.length > 1" label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="月份">
                  <el-date-picker
                    v-model="addData.month"
                    type="month"
                    placeholder="选择月"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="定时发送时间">
                  <el-date-picker
                    v-model="addData.scheduleTime"
                    type="datetime"
                    placeholder="选择定时发送时间"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="checkDate"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
                <el-link href="/static/工资条模板.xlsx">
                  <el-button type="success" plain>下载模板</el-button>
                </el-link>
                <br>
                <el-form-item label="工资条编排" :required="true" prop="content" class="messageContentBox">
                  <el-input type="textarea" :rows="5" placeholder="请输入" v-model="addData.content"></el-input>
                </el-form-item>
                <br>
                <el-form-item>
                  <el-button type="primary" @click="sendSalaryMessage">发送</el-button>
                </el-form-item>
              </el-form>
              <br>
              <el-table :data="formatData" border stripe>
                <el-table-column prop="no" label="序号" width="50"></el-table-column>
                <el-table-column prop="realName" label="姓名" width="100"></el-table-column>
                <el-table-column prop="message" label="成绩"></el-table-column>
              </el-table>
            </el-main>
          </el-container>
        </el-header>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      fileUrl: '/static/工资条模板.xlsx',
      addData: {
        month: '',
        content: '',
        schoolId: '',
        scheduleTime: ''
      },
      schoolList: [],
      classList: [],
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        classId: [{ required: true, message: '请选择班级', trigger: 'change' }],
        content: [{ required: true, message: '请输入工资条编排', trigger: 'blur' }]
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 86400000
        },
        selectableRange: '00:00:00 - 23:59:59'
      }
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
    }
    this.getSchoolList()
  },
  computed: {
    formatData () {
      let tempArray = []
      let titleArray = []
      if (this.addData.content != null) {
        let lines = this.addData.content.split('\n')
        for (var line = 0; line < lines.length; line++) {
          // console.log('lines[line]: ' + lines[line])
          if (lines[line] != null && lines[line].length > 1) {
            let tempLine = {}
            let columns = lines[line].split('\t')
            if (line === 0) {
              if (columns.length < 2) break
              titleArray = columns
              // console.log(titleArray)
            } else {
              tempLine.no = line
              tempLine.realName = columns[0]
              tempLine.message = columns[0] + this.addData.month
              for (var column = 0; column < columns.length; column++) {
                if (column === 0 || column >= titleArray.length) continue
                tempLine.message = tempLine.message + '，' + titleArray[column] + '：' + columns[column]
              }
              tempArray.push(tempLine)
            }
          }
        }
      }
      return tempArray
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            // _this.schoolList = res.data.data.list
            _this.schoolList = res.data.data.list != null ? res.data.data.list : []
            if (_this.schoolList.length > 0) _this.addData.schoolId = _this.schoolList[0].id
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    sendSalaryMessage () {
      let _this = this
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.$axios.post(this.GLOBAL.host + '/sendSalaryMessage', {
            currentUserId: _this.userInfo.id,
            schoolId: _this.addData.schoolId,
            month: _this.addData.month,
            messageList: _this.formatData,
            scheduleTime: _this.addData.scheduleTime
          }).then(res => {
            if (res.data != null && res.data.status === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
    },
    checkDate (time) {
      let now = new Date()
      if (new Date(time) < now) {
        this.addData.scheduleTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getHours()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:00`
      }
    }
  },
  watch: {
    'addData.scheduleTime' (selectTime) {
      const date = new Date(new Date(selectTime).setHours(0, 0, 0, 0)).getTime()
      const today = new Date(new Date().setHours(0, 0, 0, 0)).getTime()
      const curTime = new Date()
      if (date === today) {
        this.pickerOptions.selectableRange = `${String(curTime.getHours()).padStart(2, '0')}:${String(curTime.getMinutes()).padStart(2, '0')}:${String(curTime.getSeconds()).padStart(2, '0')} - 23:59:59`
      } else {
        this.pickerOptions.selectableRange = '00:00:00 - 23:59:59'
      }
    }
  }
})
</script>
<style>
.messageContentBox, .messageContentBox .el-form-item__content {
  width: 100%
}
</style>



// WEBPACK FOOTER //
// src/components/SendSalaryMessage.vue